// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"148":"Detail","422":"userInfo","966":"login"}[chunkId] + "." + {"148":"02901574","422":"d91cb5d1","966":"c89605da"}[chunkId] + ".js";
};